// This file is initially from https://github.com/erikras/react-redux-universal-hot-example/blob/master/src/utils/validation.js,

// Number.isInteger is ES6. It's not in PhantomJS (or IE11 according to http://caniuse.com/#search=isint), so we'll use a package from npm.
let isInteger = require('is-integer');

// which is linked from http://erikras.github.io/redux-form/#/examples/synchronous-validation?_k=dd5lso

export const isEmpty = value => value === undefined || value === null || value === '';
const join = (rules) => (value, data, props) => rules.map(rule => rule(value, data, props)).filter(error => !!error)[0]; /* first error */

export const getBsFeedback = (value) => {
	let feedback = {};

	if (value.touched) {
		feedback = {
			hasFeedback: true,
			bsStyle: value.valid ? 'success' : 'error',
			help: value.touched && (value.error ? value.error : '')
		};
	}
	return feedback;
};

export const isDate = (value) => {
	// I check for both yyyy-mm-dddd and mm/dd/yyyy format (really any digit in those places). The former will occur with HTML5 browsers when we use input type of date, but the mm/dd/yyyy is a backup if the user is allowed to type it in.
	if (!isEmpty(value) && !value.match(/\d{4}-\d{2}-\d{2}/) && !value.match(/\d?\d\\\d?\d\\\d\d\d\d/)) {
		return 'Must match date format of mm/dd/yyyy';
	}
};

export const email = (value) => {
	// Let's not start a debate on email regex. This is just for an example app!
	if (!isEmpty(value) && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
		return 'Invalid email address';
	}
};

export const required = (value) => {
	if (isEmpty(value)) {
		return 'Required';
	}
};

export const minLength = (min) => {
	return value => {
		if (!isEmpty(value) && value.length < min) {
			return `Must be at least ${ min } characters`;
		}
	};
};

export const maxLength = (max) => {
	return value => {
		if (!isEmpty(value) && value.length > max) {
			return `Must be no more than ${ max } characters`;
		}
	};
};

export const minNumber = (min, minIsInclusive = true) => {
	return value => {
		if ((minIsInclusive && value < min) || (!minIsInclusive && value <= min)) {
			return `Minimum value is ${ min } (${ minIsInclusive ? '' : 'not ' }inclusive)`;
		}
	};
};

export const maxNumber = (max, maxIsInclusive = true) => {
	return value => {
		if ((maxIsInclusive && value > max) || (!maxIsInclusive && value >= max)) {
			return `Maximum value is ${ max } (${ maxIsInclusive ? '' : 'not ' }inclusive)`;
		}
	};
};

export const integer = (value) => {
	if (!isInteger(Number(value))) {
		return 'Must be an integer';
	}
};

export const number = (value) => {
	if (!isEmpty(value) && isNaN(value)) {
		return 'Must be a number';
	}
};

export const oneOf = (enumeration) => {
	return value => {
		if (!~enumeration.indexOf(value)) {
			return `Must be one of: ${ enumeration.join(', ') }`;
		}
	};
};

export const phoneNumber = (value) => {
	if (!isEmpty(value) && value.toString().replace(/\D/g,'').length !== 10) {
		return 'Must be 10 numeric digits';
	}
};

export const match = (field) => {
	return (value, data) => {
		if (data) {
			if (value !== data[field]) {
				return 'Do not match';
			}
		}
	};
};

export const arrayValidator = (rules) => {
	return (data = []) => {
		const errors = [];
		const validator = createValidator(rules);

		data.forEach(value => {
			const error = validator(value, data);

			if (error) {
				errors.push(error);
			}
		});

		return errors;
	};
};

export const createValidator = (rules) => {
	return (data = {}, props) => {
		const errors = {};

		Object.keys(rules).forEach((key) => {
			const rule = join([].concat(rules[key])); // concat enables both functions and arrays of functions
			const error = rule(data[key], data, props);

			if (error) {
				errors[key] = error;
			}
		});

		return errors;
	};
};



// WEBPACK FOOTER //
// ./frontend/a2i/js/lib/formValidations.js